var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.date)?_c('span',{staticClass:"live-event-date"},[_vm._v(_vm._s(_vm.date)+"\n    "),(_vm.showTime)?_c('span',[_vm._v(_vm._s(_vm.$t("LiveEventDate.at"))+" "+_vm._s(_vm.time))]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }